import * as React from 'react';

const UpArrow = (props) => (
  <svg
    width={26}
    height={26}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      // eslint-disable-next-line max-len
      d="M19.5 8.87946V13.4062C19.5 13.8589 19.2563 14.1607 18.8906 14.1607C18.525 14.1607 18.2813 13.8589 18.2813 13.4062V10.6902L13.5281 16.575C13.2844 16.8768 12.9188 16.8768 12.675 16.575L10.0547 13.3308L5.91094 18.4612C5.78906 18.6121 5.66719 18.6875 5.48438 18.6875C5.30156 18.6875 5.17969 18.6121 5.05781 18.4612C4.81406 18.1594 4.81406 17.7067 5.05781 17.4049L9.62813 11.7464C9.87188 11.4446 10.2375 11.4446 10.4813 11.7464L13.1016 14.9906L17.4281 9.63393H15.2344C14.8688 9.63393 14.625 9.33214 14.625 8.87946C14.625 8.42679 14.8688 8.125 15.2344 8.125H18.8906C18.9516 8.125 19.0734 8.125 19.1344 8.20045C19.2563 8.27589 19.3781 8.42679 19.4391 8.57768C19.5 8.65312 19.5 8.80402 19.5 8.87946Z"
      fill="#22C55E"
    />
  </svg>
);
export default UpArrow;
